import {
  DropdownIndicator,
  formatGroupLabel,
  getTranslatedText,
  IndicatorSeparator
} from '@nile/components';
import { Dropdown, Label } from '@superops/ui-design-system';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import FrequencySelectField from './FrequencySelectField';
import BillingTypeSelectionfield from './BillingTypeSelectionfield';

const SubscriptionSelectField = (props) => {
  const {
    intl,
    serviceItem,
    isDisabled,
    clearChanges,
    subscriptionTypes,
    handlePropChange,
    handlePropertiesChange,
    customSubscriptionTypes
  } = props;
  const { change, frequency, quantityType } = serviceItem;
  const [isCustomSubscriptionType, setIsCustomSubscriptionType] = useState(
    frequency?.type === 'CUSTOM'
  );

  const handleChangeAndEmit = (valObj) => {
    const inputObj = {};

    if (valObj?.type && valObj?.type === 'ONCE') {
      inputObj.change = {
        quantity: null
      };
    } else if (frequency?.recurringMode === 'ARREAR' && clearChanges) {
      inputObj.change = {
        quantity: null
      };
    }

    if (change) {
      inputObj.change = {
        ...change,
        effectiveDate: null,
        quantity: change?.quantity || null
      };
    }
    handlePropertiesChange({
      frequency: {
        ...frequency,
        ...valObj
      },
      // change: {
      //   quantity: null,
      //   amount: null
      // },
      ...inputObj
    });
  };

  return (
    <div className="fx col">
      <div className="fx actr g20">
        <div className="mt25 w200">
          <Label>
            <FormattedMessage id="admin.serviceCatalog.subscriptionType" />
          </Label>
          <Dropdown
            // isClearable
            name="subscriptionTypes"
            value={subscriptionTypes.find((el) => el.value === frequency?.type)}
            onChange={(val) => {
              if (val.value === 'CUSTOM') {
                setIsCustomSubscriptionType(true);
              } else if (isCustomSubscriptionType) {
                setIsCustomSubscriptionType(false);
              }
              handleChangeAndEmit({
                type: val?.value || null,
                unit:
                  val?.value === 'CUSTOM' ? frequency?.unit || 'MONTH' : null,
                quantity:
                  val?.value === 'CUSTOM' ? frequency?.quantity || '1' : null,
                recurringMode: val.value === 'CUSTOM' ? 'UPFRONT' : null
              });
            }}
            options={subscriptionTypes}
            components={{
              IndicatorSeparator,
              DropdownIndicator
            }}
            classNamePrefix="value_selector"
            formatGroupLabel={formatGroupLabel}
            menuPlacement="auto"
            placeholder={getTranslatedText(
              intl,
              'admin.serviceCatalog.subscriptionType.placeholder'
            )}
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 })
            }}
            isDisabled={isDisabled}
          />
        </div>

        {isCustomSubscriptionType && (
          <FrequencySelectField
            intl={intl}
            frequency={frequency}
            isDisabled={isDisabled}
            onChange={handleChangeAndEmit}
            customSubscriptionTypes={customSubscriptionTypes}
          />
        )}
      </div>

      {isCustomSubscriptionType && (
        <BillingTypeSelectionfield
          frequency={frequency}
          quantityType={quantityType}
          isDisabled={isDisabled}
          handlePropChange={handlePropChange}
          handlePropertiesChange={handlePropertiesChange}
        />
      )}
    </div>
  );
};

export default SubscriptionSelectField;
